// extracted by mini-css-extract-plugin
export default {"container":"MediaQuestionSubmissionMethod__container___XGctD","dropdownButton":"MediaQuestionSubmissionMethod__dropdownButton___XDUqI"};